<ng-template #content>
  @if (icon()) {
    <span [zagIcon]="icon()!" class="zag-group-divider__icon" aria-hidden="true"></span>
  }
  <span class="zag-group-divider__label">{{ label() }}</span>
  @if (count() !== null) {
    <span class="zag-group-divider__count">{{ count() }}</span>
  }
  <span class="zag-group-divider__line" aria-hidden="true"></span>
</ng-template>
@if (collapsible()) {
  <button
    type="button"
    class="zag-group-divider__row zag-group-divider__toggle"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="controls()"
    (click)="expanded.update(isExpanded => !isExpanded)"
  >
    <ng-container [ngTemplateOutlet]="content" />
    <span
      zagIcon="expand_more"
      class="zag-group-divider__chevron"
      [class.zag-group-divider__chevron--expanded]="expanded()"
      aria-hidden="true"
    ></span>
  </button>
} @else {
  <div class="zag-group-divider__row">
    <ng-container [ngTemplateOutlet]="content" />
  </div>
}
